import LogoCapysSquare from "../Assets/img/LogoCapysSquare.png";

export function Notificate(title: string, mensagem: string) {
    if (Notification.permission === "default") {
        // usuário ainda não negou nem aceitou notificações
        Notification.requestPermission();
    }

    if (Notification.permission === "granted" && document.hidden) {
        return new Notification(title, {
            body: mensagem,
            icon: LogoCapysSquare,
        });
    }
}
